import { NodeLinkIcon, NodePageIcon } from '~components/icons';

type Props = {
  type?: string;
};

export const TypeIcon = (props: Props) => {
  switch (props.type) {
    case 'page':
      return <NodePageIcon />;
    case 'link':
      return <NodeLinkIcon />;

    default:
      return null;
  }
};
